import { WaterbodyDetail } from '@omniafishing/core';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { useUserWaterbodies } from '../../../../hooks/use_user_waterbodies';
import { WebAnalytics } from '../../../../lib/web_analytics';
import { hasAccessToken } from '../../../../redux/auth';
import { ContentWrapper } from '../../../content_wrapper/content_wrapper';
import { Spacer } from '../../../spacer/spacer';
import { WaterbodyFollowButtonLoggedIn } from '../../../waterbody_follow_button_logged_in/waterbody_follow_button_logged_in';
import { useWaterbodyWebAnalyticsArgs } from '../../waterbody_detail_lib/use_waterbody_web_analytics_args';
import styles from './waterbody_detail_follow_banner.less';
import { WaterbodyFollowFormLoggedOut } from './waterbody_detail_follow_form';

interface WaterbodyDetailFollowProps {
  waterbody: WaterbodyDetail;
  hasFishingReports: boolean;
  className: string;
}
const CURRENT_YEAR = new Date().getFullYear();

export const WaterbodyDetailFollowBanner = (props: WaterbodyDetailFollowProps) => {
  const { hasFishingReports, waterbody, className } = props;
  const { primary_name } = waterbody;
  const isLoggedIn = useSelector(hasAccessToken);
  const webAnalyticsLakeClickArgs = useWaterbodyWebAnalyticsArgs(waterbody);
  const { isWaterbodyInUserWaterbodies } = useUserWaterbodies();
  const isUserFavoriteWaterbody = isWaterbodyInUserWaterbodies(waterbody);

  return (
    <>
      {isUserFavoriteWaterbody ? (
        <div
          className={classNames({
            [styles.spacer__topTechniquesBackground]: !hasFishingReports,
          })}
        >
          <Spacer size={50} style={{ backgroundColor: '#f4f4f4', width: '100%' }} />
        </div>
      ) : (
        <>
          <div className={classNames(styles.followSection, className)}>
            <ContentWrapper>
              {isLoggedIn ? (
                <div className={styles.followContent}>
                  <p>
                    Subscribe to Email Updates for the Latest {CURRENT_YEAR} {primary_name} Fishing
                    Reports
                  </p>
                  <WaterbodyFollowButtonLoggedIn
                    waterbody={waterbody}
                    onClick={() =>
                      WebAnalytics.lakePageClick(
                        '[reports].(subscribe2)',
                        webAnalyticsLakeClickArgs
                      )
                    }
                    noPopup
                  />
                </div>
              ) : (
                <WaterbodyFollowFormLoggedOut
                  waterbody={waterbody}
                  onSubmitClick={() =>
                    WebAnalytics.lakePageClick('[reports].(subscribe2)', webAnalyticsLakeClickArgs)
                  }
                />
              )}
            </ContentWrapper>
          </div>
        </>
      )}
    </>
  );
};
